import React from 'react'
import { Box } from '@mui/material'

// Also the space it reserves at the end of the page, which full-height layouts subtract. Equal to the
// page's side gutter, so a sheet ends with the same margin below it as beside it.
export const BOTTOM_FADE_HEIGHT = 24

interface BottomScrollFadeProps {
    /** What it fades into: the sand canvas, or the white of a sheet it sits inside */
    surface?: 'canvas' | 'sheet'
    height?: number | { xs: number; sm: number }
}

// Text dissolves into the bottom of the view instead of being cut off by it, a cue that the page
// goes on. Sticky at the end of its container: while content runs past the view it pins to the
// bottom over that content, and at the end it settles into its own space below the last line, so
// nothing stays hidden.
export const BottomScrollFade: React.FC<BottomScrollFadeProps> = ({
    surface = 'canvas',
    height = BOTTOM_FADE_HEIGHT,
}) => (
    <Box
        aria-hidden="true"
        sx={{
            position: 'sticky',
            bottom: 0,
            height,
            pointerEvents: 'none',
            // Outlined field labels sit at z-index 1; later in the page, this wins the tie
            zIndex: 1,
            background: (theme) => {
                const color = surface === 'sheet' ? theme.palette.background.paper : theme.palette.background.default
                return `linear-gradient(to bottom, transparent, ${color})`
            },
        }}
    />
)
